import { styles } from "@/components/installementStyle";
import { colors } from "@/utils/const";
import { Box, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { NoInternetSVG } from "@/components/NoInternetSVG";
import en from "../../locales/en";
import ar from "../../locales/ar";

const NoInternetConnection = () => {
  const router = useRouter();
  const { locale } = router;
  const t = locale === "en" ? en : ar;

  const handleReloadAndNavigate = () => {
    const previousPage = localStorage.getItem("lastVisitedPage");
    router.push(previousPage || "/");
  };

  useEffect(() => {
    // Redirect immediately if online (e.g., after page refresh)
    if (navigator.onLine) {
      handleReloadAndNavigate();
    }

    const handleOnline = () => {
      handleReloadAndNavigate();
    };

    window.addEventListener("online", handleOnline);

    return () => {
      window.removeEventListener("online", handleOnline);
    };
  }, []);

  return (
    <Box
      sx={{
        m: "auto",
        py: { xs: 2, md: 4 },
        px: { xs: 2 },
        height: "100vh",
        display:"flex",
        justifyContent:"center",
        alignItems:"center"
      }}
    >
      <Box>
        <NoInternetSVG />

        <Typography
          component="h1"
          variant="h5"
          sx={{
            color: colors.light_black,
            fontSize: "32px",
            fontWeight: "700",
            display: "flex",
            justifyContent: "center",
            padding: "16px 0 0 0",
          }}
        >
          {t.internetConnectionPage.title}
        </Typography>

        <Typography
          component="p"
          sx={{
            color: colors.light_black,
            fontSize: "16px",
            display: "flex",
            justifyContent: "center",
            textAlign: "center",
            padding: "16px 0 0 0",
          }}
        >
          {t.internetConnectionPage.subTitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default NoInternetConnection;
